import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIsSquareMeterPrice = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('price_sm')(jsonQuery),
);
